if (!customElements.get('klarna-widget')) {
  customElements.define(
    'klarna-widget',
    class KlarnaWidget extends HTMLElement {
      connectedCallback() {
        this.dialog = this.querySelector('[data-klarna-dialog]');
        if (!this.dialog) return;

        this.onOpen = this.open.bind(this);
        this.onClose = this.close.bind(this);
        this.onKeydown = this.handleKeydown.bind(this);

        this.querySelectorAll('[data-klarna-open]').forEach((button) => {
          button.addEventListener('click', this.onOpen);
        });
        this.querySelectorAll('[data-klarna-close]').forEach((button) => {
          button.addEventListener('click', this.onClose);
        });
        this.dialog.addEventListener('click', (event) => {
          if (event.target === this.dialog) this.close(event);
        });
      }

      disconnectedCallback() {
        this.close({ restoreFocus: false });
        document.removeEventListener('keydown', this.onKeydown);
      }

      open(event) {
        event?.preventDefault();
        this.lastFocus = document.activeElement;
        document.body.appendChild(this.dialog);
        this.dialog.hidden = false;
        document.documentElement.classList.add('klarna-popup-open');
        document.addEventListener('keydown', this.onKeydown);
        this.dialog.querySelector('.klarna-popup__close-icon')?.focus();
      }

      close(event) {
        if (event?.preventDefault) event.preventDefault();
        if (!this.dialog || this.dialog.hidden) return;

        this.dialog.hidden = true;
        document.documentElement.classList.remove('klarna-popup-open');
        document.removeEventListener('keydown', this.onKeydown);
        if (this.dialog.parentElement === document.body) {
          this.appendChild(this.dialog);
        }

        if (event?.restoreFocus === false) return;
        this.lastFocus?.focus?.();
      }

      handleKeydown(event) {
        if (event.key === 'Escape') this.close(event);
      }
    }
  );
}
